import React, {PureComponent} from 'react';
import $ from 'jquery';

import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

class TeamInfo extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            info: {
                brand: "---",
                drivers: [],
                id: -1,
                imei: "---",
                livery_number: "--",
                model: "---",
                photo_path: "noimage.png",
                car_class: "---",
                car_rating: "---",
                team_name: "---",
                short_name: "---",
                spectator_view_key_code: "---",
                title: "---",
                userID: -1,
            }
        };
    }

    componentDidMount() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getCarDetails',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            data: {
                userID: this.props.match.params.userID,
                carID: this.props.match.params.carID,
                sessionID: this.props.match.params.sessionID,
                eventID: this.props.match.params.eventID,
            },
            success: function (data) {
                try {
                    helper.setState({
                        info: data
                    });
                } catch (e) {
                    if (e) {
                        console.error('Error:', e);
                    }
                }
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
            }
        });
    }

    render() {
        return (
            <div className={"container w3-animate-fading"}>
                <div className={"App_modernContainer"} style={{padding: 50}}>
                    <div className={"row"}>
                        <div className={"panel panel-default"}>
                            <div className="panel-heading">
                                <h4 className="panel-title teamInfo_title">#{this.state.info.livery_number} {this.state.info.team_name}</h4>
                            </div>
                            <div className="panel-body">
                                <div className={"row"}>
                                    <div className={"col-md-3"}>
                                        <img src={serverIP + ":" + backendPort + "/uploads/" + (this.state.info.photo_path ? this.state.info.photo_path : "noimage.png")}
                                             className={"img-thumbnail"}
                                             alt={"..."}
                                        />
                                    </div>
                                    <div className={"col-md-8"}>
                                        <table className="table" style={{fontSize: 18}}>
                                            <tbody>
                                            <tr>
                                                <th className={"teamInfo_label"}>{this.props.t("class")}</th>
                                                <td className={"App_bold_text"}>{this.state.info.primary_class}</td>
                                            </tr>
                                            <tr>
                                                <th className={"teamInfo_label"}>{this.props.t("rating")}</th>
                                                <td className={"App_bold_text"}>{this.state.info.secondary_class}</td>
                                            </tr>
                                            <tr>
                                                <th className={"teamInfo_label"}>{this.props.t("brand")}</th>
                                                <td className={"App_bold_text"}>{this.state.info.brand}</td>
                                            </tr>
                                            <tr>
                                                <th className={"teamInfo_label"}>{this.props.t("model")}</th>
                                                <td className={"App_bold_text"}>{this.state.info.model}</td>
                                            </tr>
                                            <tr>
                                                <th className={"teamInfo_label"}>{this.props.t("obsNotes")}</th>
                                                <td className={"App_bold_text"}>{this.state.info.car_obs}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={"row"}>
                        <div className="panel panel-default">
                            <div className="panel-heading">
                                <h4 className="panel-title teamInfo_title">{this.props.t("drivers")}</h4>
                            </div>
                            <div className="panel-body" style={{padding: 0}}>
                                {this.state.info.drivers.map((driver) => {
                                    return (
                                        <div className={"container"} key={driver.id}>
                                            <div className={"row justify-content-md-center"} style={{padding: 0, maring: 0}}>
                                                <div className={"col-xs-12 row-flex"}>
                                                    <div className={"col-xs-2 text-right col-md-offset-2"} key={driver.id}>
                                                        <img
                                                            className={"img-responsive"}
                                                            src={driver.photo_path ? (serverIP + ":" + backendPort + "/uploads/drivers/" + driver.photo_path) : (serverIP + ":" + backendPort + "/uploads/noimage_driver.png")}
                                                            alt="..."/>
                                                    </div>
                                                    <div className={"col-md-8 col-lg-8"}>
                                                        <div className={"col-sm-8 text-left App_bold_text"}>
                                                            <h3>
                                                                <b>{driver.name}</b>
                                                            </h3>
                                                        </div>
                                                        <div className={"col-sm-8"}>
                                                            <table className="table" style={{fontSize: 16}}>
                                                                <tbody>
                                                                <tr>
                                                                    <th className={"teamInfo_label"}>{this.props.t("nationality")}</th>
                                                                    <td className={"App_bold_text"}>{driver.nationality}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th className={"teamInfo_label"}>{this.props.t("eventRating")}</th>
                                                                    <td className={"App_bold_text"}>{driver.rating}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th className={"teamInfo_label"}>{this.props.t("eventRFID")}</th>
                                                                    <td className={"App_bold_text"}>{driver.tag_external_identifier}</td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation("translations")(withCookies(TeamInfo));